import { useLayoutEffect, useRef, useState } from 'react';
import type { TemplateId } from '@/types/portfolio';
import { getTemplateRenderer } from '@/features/editor/preview/templates';
import { SAMPLE_DRAFT, SAMPLE_ENABLED } from './sampleDraft';

const RENDER_WIDTH = 1200;

interface TemplatePreviewProps {
  template: TemplateId;
}

export function TemplatePreview({ template }: TemplatePreviewProps) {
  const Renderer = getTemplateRenderer(template);
  const wrapRef = useRef<HTMLDivElement | null>(null);
  const [scale, setScale] = useState(0.35);

  useLayoutEffect(() => {
    const el = wrapRef.current;
    if (!el) return;
    const observer = new ResizeObserver(() => {
      const w = el.clientWidth;
      if (w > 0) setScale(w / RENDER_WIDTH);
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={wrapRef} className="relative h-full w-full overflow-hidden bg-canvas">
      <div
        style={{
          width: RENDER_WIDTH,
          transform: `scale(${scale})`,
          transformOrigin: 'top left',
        }}
      >
        <Renderer draft={SAMPLE_DRAFT} enabled={SAMPLE_ENABLED} ownerName="Alex Rivera" />
      </div>
    </div>
  );
}
